<template>
    <div>
        <ValidationProvider rules="required" v-slot="v">
            <v-text-field dense v-model="dateFormatted" :label="etiqueta" append-icon="mdi-calendar"
                @click:append="activarDialogo" @blur="date = parseDate(dateFormatted)"
                :error-messages="v.errors[0]"></v-text-field>
        </ValidationProvider>
        <v-dialog v-model="modal" persistent width="290px">
            <v-date-picker v-model="date" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="cancelar">
                    Cancel
                </v-btn>
                <v-btn text color="primary" @click="seleccionarFecha">
                    OK
                </v-btn>
            </v-date-picker>
        </v-dialog>
    </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
    components: {
        ValidationProvider,
    },
    props: ['etiqueta', 'fecha', 'tipo'],
    data() {
        return {
            date: new Date().toISOString().substr(0, 10),
            dateFormatted: this.formatDate(''),
            modal: false,
        };
    },
    methods: {
        seleccionarFecha() {
            this.$emit('fechaSeleccionada', this.date, this.tipo);
            this.modal = false;
        },
        cancelar() {
            this.date = '';
            this.modal = false;
        },
        activarDialogo() {
            this.modal = true;
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split('-');
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [day, month, year] = date.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        },
    },
    computed: {
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
    },
    watch: {
        fecha(val) {
            this.date = val;
        },
        date(val) {
            this.dateFormatted = this.formatDate(this.date);
        },
    },
};
</script>